import { render, staticRenderFns } from "./MaterialEventDetail.vue?vue&type=template&id=08581fec&scoped=true"
import script from "./MaterialEventDetail.vue?vue&type=script&lang=js"
export * from "./MaterialEventDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08581fec",
  null
  
)

/* custom blocks */
import block0 from "@/components/CoreMaterial/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FCoreMaterial%2FMaterialEvent%2FMaterialEventDetail.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports